"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Home_vue_1 = __importDefault(require("../../pages/frontend/home/Home.vue"));
const Verification_vue_1 = __importDefault(require("../../pages/frontend/verification/Verification.vue"));
const Reservation_vue_1 = __importDefault(require("../../pages/frontend/reservation/Reservation.vue"));
const Thankyou_vue_1 = __importDefault(require("../../pages/frontend/thankyou/Thankyou.vue"));
exports.default = [
    {
        name: "frontend_home",
        path: "/",
        component: Home_vue_1.default,
        meta: { requiresAppAuth: false, title: "Időpontfoglaló" },
    },
    {
        name: "frontend_verification",
        path: "/verification",
        component: Verification_vue_1.default,
        meta: { requiresAppAuth: false, title: "Authentikáció" },
    },
    {
        name: "frontend_reservation",
        path: "/reservation",
        component: Reservation_vue_1.default,
        meta: { requiresAppAuth: true, title: "Foglalás" },
    },
    {
        name: "frontend_thankyou",
        path: "/thankyou",
        component: Thankyou_vue_1.default,
        meta: { requiresAppAuth: false, title: "Köszönjük a foglalását" },
    },
    {
        name: "frontend_get_locations_api",
        path: "/api/locations/getbyprefix",
        redirect: "",
        meta: { requiresAppAuth: true },
    },
    {
        name: "frontend_get_services_api",
        path: "/api/services/get",
        redirect: "",
        meta: { requiresAppAuth: true },
    },
];
